export interface RubricaCadastroResult {
  codiEmp: number;
  codRubrEsocial: string;
  iEventosDominio: number;
  descricao?: string | null;
  status: string;
  error?: string | null;
}

export interface ImportRubricaLinha {
  linha: number;
  codiEmp: number;
  codRubrEsocial: string;
  iEventosDominio: number;
  descricao?: string | null;
  status: string;
}

export interface ImportRubricasResult {
  nomeArquivo?: string;
  totalLinhas: number;
  inseridas: number;
  atualizadas: number;
  semAlteracao: number;
  linhas: ImportRubricaLinha[];
  avisos: string[];
  error?: string | null;
}

export function rubricaJaCadastrada(status: string | null | undefined): boolean {
  const texto = (status ?? '').toLocaleLowerCase('pt-BR');
  return texto.includes('já cadastrada') || texto.includes('ja cadastrada') || texto.startsWith('atualizada');
}
